module.exports = __webpack_public_path__ + "img/with_incomes_expenses.66cc362f.png";